import { IndexModel } from "../Support/IndexModel";
export class CampaignProductIndex extends IndexModel {
    slug;
    endpoint = '';
    constructor(params) {
        super();
        this.slug = params.slug;
        this.endpoint = 'campaign/' + this.slug + '/product';
        this.filters = {};
    }
    getData() {
        return super.getData();
    }
}
